import { render, staticRenderFns } from "./voxuy.vue?vue&type=template&id=20aca368&scoped=true"
import script from "./voxuy.vue?vue&type=script&lang=js"
export * from "./voxuy.vue?vue&type=script&lang=js"
import style0 from "./voxuy.vue?vue&type=style&index=0&id=20aca368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aca368",
  null
  
)

export default component.exports